export const SET_VISITORS_SUMMARY_BY_FILTERS = "ANALYTICS/SET_VISITORS_SUMMARY_BY_FILTERS";
export const GET_VISITORS_SUMMARY_BY_FILTERS = "ANALYTICS/GET_VISITORS_SUMMARY_BY_FILTERS";
